var map = {
	"./1/symbol_0.png": "cdc4",
	"./1/symbol_1.png": "a1960",
	"./1/symbol_2.png": "160e",
	"./1/symbol_3.png": "a407",
	"./1/symbol_4.png": "2f5d",
	"./1/symbol_5.png": "c6bd",
	"./1/symbol_6.png": "ba88",
	"./1/symbol_7.png": "161a",
	"./1/symbol_8.png": "49be",
	"./double_sword.png": "2cc7",
	"./missing.png": "043e",
	"./shield.png": "beb2",
	"./sword.png": "35d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "83cc";